const baseUrl: string = process.env.REACT_APP_API_URL || '';

class City {
    private uri: string;

    constructor(uri: string) {
        this.uri = uri;
    }

    public read = (params: any) => ({
        baseUrl,
        method: 'get',
        params,
        uri: this.uri,
    });
}

export default new City('/profiles/v1/cities');



// WEBPACK FOOTER //
// ./src/libraries/api/city.tsx